const BASE = process.env.REACT_APP_API_URL || '';

async function j(url, opts) {
  const res = await fetch(`${BASE}${url}`, {
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  if (!res.ok) throw new Error(`API ${res.status}`);
  return res.json();
}

export const api = {
  menu: () => j('/api/menu'),
  cart: (sid) => j(`/api/cart/${sid}`),
  addToCart: (sid, menuItemId, quantity = 1) =>
    j(`/api/cart/${sid}/add`, { method: 'POST', body: JSON.stringify({ menuItemId, quantity }) }),
  removeFromCart: (sid, menuItemId) =>
    j(`/api/cart/${sid}/remove`, { method: 'POST', body: JSON.stringify({ menuItemId }) }),
  clearCart: (sid) => j(`/api/cart/${sid}/clear`, { method: 'POST' }),
  chat: (sid, message, history) =>
    j(`/api/chat/${sid}`, { method: 'POST', body: JSON.stringify({ message, history }) }),
};

export function getSessionId() {
  let sid = localStorage.getItem('ainatalk_session');
  if (!sid) {
    sid = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('ainatalk_session', sid);
  }
  return sid;
}
